import { _ as _async_to_generator } from "@swc/helpers/_/_async_to_generator";
import { _ as _sliced_to_array } from "@swc/helpers/_/_sliced_to_array";
import { _ as _ts_generator } from "@swc/helpers/_/_ts_generator";
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { Core } from "@faire/design-tokens";
import { ContinueToNextViewButton } from "@faire/retailer-visitor-shared/components/AppSignIn/components/ContinueToNextViewButton";
import { convertErrorToLoginError } from "@faire/retailer-visitor-shared/components/AppSignIn/components/convertErrorToLoginError";
import { EmailSentScenario } from "@faire/retailer-visitor-shared/components/AppSignIn/components/EmailSentWaitingView";
import { ErrorMessage } from "@faire/retailer-visitor-shared/components/AppSignIn/components/ErrorMessage";
import { logErrorSignIn } from "@faire/retailer-visitor-shared/components/AppSignIn/components/logErrorSignIn";
import { LoginError } from "@faire/retailer-visitor-shared/components/AppSignIn/components/LoginError";
import { LoginWrapper } from "@faire/retailer-visitor-shared/components/AppSignIn/components/styled";
import { View } from "@faire/retailer-visitor-shared/components/AppSignIn/components/View";
import { useSignInEventTracker } from "@faire/retailer-visitor-shared/components/AppSignIn/useSignInEventTracker";
import { useFetchHCaptchaToken } from "@faire/retailer-visitor-shared/hooks/hCaptcha/useFetchHCaptchaToken";
import { useHCaptchaLogin } from "@faire/retailer-visitor-shared/hooks/hCaptcha/useHCaptchaLogin";
import { handleKeyDown } from "@faire/retailer-visitor-shared/lib/handleKeyDown";
import { isValidEmail } from "@faire/retailer-visitor-shared/lib/validation";
import { getSettingEnableHCaptchaForLoginData } from "@faire/retailer-visitor-shared/settings/getSettingEnableHCaptchaForLoginData";
import { useAssignSettingMagicLinkProminenceXP, useAssignSettingSignInMagicLinkImprovements, useIsNewMagicLinkExperience, useSettingMagicLinkProminenceXP } from "@faire/retailer-visitor-shared/settings/useSettingSignInImprovements";
import { useSSOPasswordStore } from "@faire/retailer-visitor-shared/stores/domain/SSO/useSSOPasswordStore";
import { useSSOStore } from "@faire/retailer-visitor-shared/stores/domain/SSO/useSSOStore";
import { emitDatadogError } from "@faire/web--source/common/datadog/rum";
import { getWindowOrThrow } from "@faire/web--source/common/globals/getWindow";
import { useStrictLocalization } from "@faire/web--source/common/localization/localize";
import { Button } from "@faire/web--source/slate/Button";
import { Eye, EyeClosed } from "@faire/web--source/slate/icons/foundation/Eye";
import { Input } from "@faire/web--source/slate/Input";
import { HorizontalLine, Row } from "@faire/web--source/slate/Layout";
import { Spacer } from "@faire/web--source/slate/spacing";
import { Typography } from "@faire/web--source/slate/Typography";
import { StrictLocalMsg } from "@faire/web--source/ui/lib/localization";
import userLoginData from "@faire/web-api--source/api/user/login-data/post";
import resetPasswordWithEmail from "@faire/web-api--source/api/user/reset-password/post";
import resetPassword from "@faire/web-api--source/api/user/reset-password/userToken/post";
import login from "@faire/web-api--source/api/v2/users/login/post";
import { trackRetailerPortalLoginModalEnterEmail } from "@faire/web-api--source/events/retailerPortal/actionUnknown/loginModalEnterEmail";
import { trackRetailerPortalLoginModalLoggedInWithPassword } from "@faire/web-api--source/events/retailerPortal/actionUnknown/loginModalLoggedInWithPassword";
import { trackRetailerPortalLoginModalMagicLink } from "@faire/web-api--source/events/retailerPortal/actionUnknown/loginModalMagicLink";
import { trackSigninMagicCodeClick } from "@faire/web-api--source/events/signin/click/magicCode";
import { trackSigninResetPasswordClick } from "@faire/web-api--source/events/signin/click/resetPassword";
import { trackSigninSignInPasswordSubmitClick } from "@faire/web-api--source/events/signin/click/signInPasswordSubmit";
import { trackSigninTriggersMfaSubmit } from "@faire/web-api--source/events/signin/submit/triggersMfa";
import { trackSigninLoginWithPasswordSuccess } from "@faire/web-api--source/events/signin/success/loginWithPassword";
import { trackSigninResetPasswordSuccess } from "@faire/web-api--source/events/signin/success/resetPassword";
import { ILoginDataRequest } from "@faire/web-api--source/indigofair/data/ILoginDataRequest";
import { ILoginRequest } from "@faire/web-api--source/indigofair/data/ILoginRequest";
import { ISendResetPasswordRequest } from "@faire/web-api--source/indigofair/data/ISendResetPasswordRequest";
import { LoginState } from "@faire/web-api--source/indigofair/data/LoginState";
import { ISignInMagicLinkXP } from "@faire/web-api--source/indigofair/seo/ISignInMagicLinkXP";
import React, { useCallback, useEffect, useState } from "react";
import styled from "styled-components";
export var EnterPasswordView = function(param) {
    var signInTitle = param.signInTitle, defaultEmail = param.defaultEmail, userToken = param.userToken, withEmail = param.withEmail, sendResetEmail = param.sendResetEmail, onComplete = param.onComplete, onLogin = param.onLogin;
    var strictLocalize = useStrictLocalization().strictLocalize;
    var _useState = _sliced_to_array(useState(""), 2), password = _useState[0], setPassword = _useState[1];
    var _useState1 = _sliced_to_array(useState(), 2), error = _useState1[0], setError = _useState1[1];
    var _useState2 = _sliced_to_array(useState(0), 2), incorrectPasswordErrorShowTime = _useState2[0], setIncorrectPasswordErrorShowTime = _useState2[1];
    var _useState3 = _sliced_to_array(useState(undefined), 2), passwordError = _useState3[0], setPasswordError = _useState3[1];
    var _useState4 = _sliced_to_array(useState(false), 2), isLoading = _useState4[0], setIsLoading = _useState4[1];
    var fetchHCaptchaToken = useFetchHCaptchaToken(getSettingEnableHCaptchaForLoginData()).fetchHCaptchaToken;
    var isMagicLinkImprovement = useIsNewMagicLinkExperience();
    var magicLinkProminenceVariant = useSettingMagicLinkProminenceXP();
    var assignSettingMagicLinkProminenceXP = useAssignSettingMagicLinkProminenceXP();
    var trackFieldValue = useSignInEventTracker("ENTER_PASSWORD").trackFieldValue;
    var assignSettingSignInMagicLinkImprovements = useAssignSettingSignInMagicLinkImprovements();
    var isActive = useSSOStore().isActive;
    var userHasPassword = useSSOPasswordStore().userHasPassword;
    var validatePassword = useCallback(/*#__PURE__*/ _async_to_generator(function() {
        return _ts_generator(this, function(_state) {
            if (password.length === 0) {
                setPasswordError(strictLocalize({
                    id: "MF++dd",
                    defaultMessage: [
                        {
                            type: 0,
                            value: "Enter a password to continue"
                        }
                    ]
                }));
                return [
                    2,
                    false
                ];
            }
            return [
                2,
                true
            ];
        });
    }), [
        password.length,
        strictLocalize
    ]);
    var onForgotPassword = useCallback(/*#__PURE__*/ function() {
        var _ref = _async_to_generator(function(emailAddress) {
            var noRetailerMessage, loginData, newUserToken, e, loginError, e1, e2;
            return _ts_generator(this, function(_state) {
                switch(_state.label){
                    case 0:
                        if (!isValidEmail(emailAddress)) {
                            return [
                                2
                            ];
                        }
                        noRetailerMessage = strictLocalize({
                            id: "SV5et3",
                            defaultMessage: [
                                {
                                    type: 0,
                                    value: "No associated retailer with email address"
                                }
                            ]
                        });
                        if (!withEmail) return [
                            3,
                            10
                        ];
                        _state.label = 1;
                    case 1:
                        _state.trys.push([
                            1,
                            7,
                            8,
                            9
                        ]);
                        setIsLoading(true);
                        return [
                            4,
                            fetchHCaptchaToken(true).then(function() {
                                return userLoginData(ILoginDataRequest.build({
                                    email_address: emailAddress
                                }));
                            })
                        ];
                    case 2:
                        loginData = _state.sent();
                        newUserToken = loginData.user_token;
                        if (!newUserToken) return [
                            3,
                            4
                        ];
                        return [
                            4,
                            resetPassword(newUserToken, ISendResetPasswordRequest.build({}))
                        ];
                    case 3:
                        _state.sent();
                        trackSigninResetPasswordSuccess(View.ENTER_LOGIN, "LOGIN_DATA_USER_TOKEN");
                        return [
                            3,
                            6
                        ];
                    case 4:
                        return [
                            4,
                            resetPasswordWithEmail(ILoginDataRequest.build({
                                email_address: emailAddress
                            }))
                        ];
                    case 5:
                        _state.sent();
                        trackSigninResetPasswordSuccess(View.ENTER_LOGIN, "LOGIN_DATA_EMAIL_ADDRESS");
                        _state.label = 6;
                    case 6:
                        onComplete({
                            nextView: View.RESET_PASSWORD,
                            userToken: newUserToken,
                            email: emailAddress,
                            obfuscatedEmail: loginData.partial_alias
                        });
                        return [
                            3,
                            9
                        ];
                    case 7:
                        e = _state.sent();
                        emitDatadogError(e);
                        loginError = convertErrorToLoginError(e, strictLocalize);
                        setError(loginError);
                        return [
                            3,
                            9
                        ];
                    case 8:
                        setIsLoading(false);
                        return [
                            7
                        ];
                    case 9:
                        return [
                            3,
                            23
                        ];
                    case 10:
                        if (!userToken) return [
                            3,
                            16
                        ];
                        _state.label = 11;
                    case 11:
                        _state.trys.push([
                            11,
                            13,
                            14,
                            15
                        ]);
                        setIsLoading(true);
                        return [
                            4,
                            resetPassword(userToken, ISendResetPasswordRequest.build({}))
                        ];
                    case 12:
                        _state.sent();
                        trackSigninResetPasswordSuccess(View.ENTER_LOGIN, "USER_TOKEN");
                        onComplete({
                            nextView: View.RESET_PASSWORD
                        });
                        return [
                            3,
                            15
                        ];
                    case 13:
                        e1 = _state.sent();
                        setError(convertErrorToLoginError(e1, strictLocalize));
                        return [
                            3,
                            15
                        ];
                    case 14:
                        setIsLoading(false);
                        return [
                            7
                        ];
                    case 15:
                        return [
                            3,
                            23
                        ];
                    case 16:
                        if (!emailAddress) return [
                            3,
                            22
                        ];
                        _state.label = 17;
                    case 17:
                        _state.trys.push([
                            17,
                            19,
                            20,
                            21
                        ]);
                        setIsLoading(true);
                        return [
                            4,
                            resetPasswordWithEmail(ILoginDataRequest.build({
                                email_address: emailAddress
                            }))
                        ];
                    case 18:
                        _state.sent();
                        trackSigninResetPasswordSuccess(View.ENTER_LOGIN, "EMAIL_ADDRESS");
                        onComplete({
                            nextView: View.RESET_PASSWORD
                        });
                        return [
                            3,
                            21
                        ];
                    case 19:
                        e2 = _state.sent();
                        setError(convertErrorToLoginError(e2, strictLocalize));
                        return [
                            3,
                            21
                        ];
                    case 20:
                        setIsLoading(false);
                        return [
                            7
                        ];
                    case 21:
                        return [
                            3,
                            23
                        ];
                    case 22:
                        setError(new LoginError(noRetailerMessage));
                        _state.label = 23;
                    case 23:
                        return [
                            2
                        ];
                }
            });
        });
        return function(emailAddress) {
            return _ref.apply(this, arguments);
        };
    }(), [
        strictLocalize,
        withEmail,
        userToken,
        fetchHCaptchaToken,
        onComplete
    ]);
    useEffect(function() {
        if (withEmail) {
            trackRetailerPortalLoginModalEnterEmail("PASSWORD");
            if (sendResetEmail) {
                onForgotPassword(defaultEmail);
            }
        }
    }, [
        withEmail,
        defaultEmail,
        sendResetEmail,
        onForgotPassword
    ]);
    useEffect(function() {
        if (isActive && !userHasPassword) {
            logErrorSignIn("ENTER_PASSWORD", "Wrong view for SSO user without password");
        }
    }, [
        isActive,
        userHasPassword
    ]);
    useEffect(function() {
        assignSettingMagicLinkProminenceXP();
    }, [
        assignSettingMagicLinkProminenceXP
    ]);
    var onMagicLink = /*#__PURE__*/ function() {
        var _ref = _async_to_generator(function() {
            var e;
            return _ts_generator(this, function(_state) {
                switch(_state.label){
                    case 0:
                        assignSettingSignInMagicLinkImprovements();
                        trackSigninMagicCodeClick(View.ENTER_PASSWORD);
                        if (!isValidEmail(defaultEmail)) {
                            return [
                                2
                            ];
                        }
                        _state.label = 1;
                    case 1:
                        _state.trys.push([
                            1,
                            3,
                            4,
                            5
                        ]);
                        setIsLoading(true);
                        return [
                            4,
                            login(ILoginRequest.build({
                                email_address: defaultEmail,
                                user_token: !defaultEmail ? userToken : undefined
                            }))
                        ];
                    case 2:
                        _state.sent();
                        trackRetailerPortalLoginModalMagicLink();
                        if (isMagicLinkImprovement) {
                            onComplete({
                                nextView: View.MAGIC_LINK_SENT,
                                email: defaultEmail
                            });
                        } else {
                            onComplete({
                                nextView: View.ENTER_CODE,
                                email: defaultEmail
                            });
                        }
                        return [
                            3,
                            5
                        ];
                    case 3:
                        e = _state.sent();
                        setError(convertErrorToLoginError(e, strictLocalize));
                        return [
                            3,
                            5
                        ];
                    case 4:
                        setIsLoading(false);
                        return [
                            7
                        ];
                    case 5:
                        return [
                            2
                        ];
                }
            });
        });
        return function onMagicLink() {
            return _ref.apply(this, arguments);
        };
    }();
    var onContinue = /*#__PURE__*/ function() {
        var _ref = _async_to_generator(function() {
            var isValidPassword, isEmailValid, loginRequest, _ref, mfa_description, mfa_title, user, mfa_options, login_state, cred, e, loginError, isIncorrectPasswordError;
            return _ts_generator(this, function(_state) {
                switch(_state.label){
                    case 0:
                        return [
                            4,
                            validatePassword()
                        ];
                    case 1:
                        isValidPassword = _state.sent();
                        isEmailValid = isValidEmail(defaultEmail);
                        if (!isEmailValid || !isValidPassword) {
                            trackSigninSignInPasswordSubmitClick("INCORRECT", "EMPTY_PASSWORD");
                            return [
                                2
                            ];
                        }
                        _state.label = 2;
                    case 2:
                        _state.trys.push([
                            2,
                            4,
                            5,
                            6
                        ]);
                        loginRequest = ILoginRequest.build({
                            password: password,
                            email_address: defaultEmail,
                            user_token: !defaultEmail ? userToken : undefined,
                            enable_mfa_method_selection: true
                        });
                        setIsLoading(true);
                        return [
                            4,
                            hCaptchaLogin(loginRequest)
                        ];
                    case 3:
                        _ref = _state.sent(), mfa_description = _ref.mfa_description, mfa_title = _ref.mfa_title, user = _ref.user, mfa_options = _ref.mfa_options, login_state = _ref.login_state;
                        trackSigninLoginWithPasswordSuccess(View.ENTER_LOGIN, login_state);
                        if (login_state === LoginState.ISSUED_AUTOMATIC_LOGIN_CODE) {
                            onComplete({
                                nextView: View.MAGIC_LINK_SENT,
                                password: password,
                                email: defaultEmail,
                                userToken: userToken,
                                emailSentScenario: EmailSentScenario.AUTO
                            });
                            return [
                                2
                            ];
                        }
                        if (login_state === LoginState.MFA_METHOD_SELECTION_REQUIRED) {
                            trackSigninSignInPasswordSubmitClick("MFA_TRIGGERED", login_state);
                            trackSigninTriggersMfaSubmit("ENTER_PASSWORD");
                            onComplete({
                                nextView: View.SELECT_MFA_OPTION,
                                password: password,
                                userToken: userToken,
                                mfaOptions: mfa_options,
                                mfaTitle: mfa_title,
                                mfaDescription: mfa_description
                            });
                            return [
                                2
                            ];
                        }
                        if (login_state === LoginState.MFA_REQUIRED) {
                            trackSigninSignInPasswordSubmitClick("MFA_TRIGGERED", login_state);
                            trackSigninTriggersMfaSubmit("ENTER_PASSWORD");
                            onComplete({
                                nextView: View.ENTER_MFA,
                                password: password,
                                mfaDescription: mfa_description,
                                mfaTitle: mfa_title
                            });
                            return [
                                2
                            ];
                        }
                        if (!user) {
                            trackSigninSignInPasswordSubmitClick("INCORRECT", "INVALID_USER");
                            setError(new LoginError(strictLocalize({
                                id: "6Qgt73",
                                defaultMessage: [
                                    {
                                        type: 0,
                                        value: "Invalid credentials"
                                    }
                                ]
                            })));
                            return [
                                2
                            ];
                        }
                        if ("credentials" in getWindowOrThrow().navigator && "PasswordCredential" in getWindowOrThrow()) {
                            cred = new PasswordCredential({
                                id: defaultEmail,
                                password: password
                            });
                            getWindowOrThrow().navigator.credentials.store(cred).catch(function() {
                            // Ignore.
                            });
                        }
                        trackRetailerPortalLoginModalLoggedInWithPassword();
                        onLogin(user);
                        trackSigninSignInPasswordSubmitClick("CORRECT", "NO_MFA");
                        onComplete({
                            nextView: View.LOADING
                        });
                        return [
                            3,
                            6
                        ];
                    case 4:
                        e = _state.sent();
                        loginError = convertErrorToLoginError(e, strictLocalize);
                        logErrorSignIn("ENTER_PASSWORD", loginError.message);
                        isIncorrectPasswordError = loginError.httpStatusCode === 400;
                        if (isIncorrectPasswordError) {
                            trackSigninSignInPasswordSubmitClick("INCORRECT", "INVALID_PASSWORD");
                        }
                        if (loginError.httpStatusCode === 429) {
                            setError(new LoginError(strictLocalize({
                                id: "S8h6wQ",
                                defaultMessage: [
                                    {
                                        type: 0,
                                        value: "Exceeded maximum allowed number of login attempts"
                                    }
                                ]
                            })));
                        } else if (isIncorrectPasswordError && incorrectPasswordErrorShowTime > 0) {
                            setPasswordError(strictLocalize({
                                id: "PHTcwX",
                                defaultMessage: [
                                    {
                                        type: 0,
                                        value: "Incorrect password"
                                    }
                                ]
                            }));
                        } else if (isIncorrectPasswordError) {
                            setIncorrectPasswordErrorShowTime(function(prevState) {
                                return prevState + 1;
                            });
                            setPasswordError(strictLocalize({
                                id: "NxodaO",
                                defaultMessage: [
                                    {
                                        type: 0,
                                        value: "Incorrect password, please try again"
                                    }
                                ]
                            }));
                        } else {
                            setError(loginError);
                        }
                        return [
                            3,
                            6
                        ];
                    case 5:
                        setIsLoading(false);
                        return [
                            7
                        ];
                    case 6:
                        return [
                            2
                        ];
                }
            });
        });
        return function onContinue() {
            return _ref.apply(this, arguments);
        };
    }();
    var hCaptchaLogin = useHCaptchaLogin().hCaptchaLogin;
    var handleChange = function(event) {
        setPasswordError(undefined);
        setError(undefined);
        setPassword(event.currentTarget.value);
    };
    var _useState5 = _sliced_to_array(useState(false), 2), showPassword = _useState5[0], setShowPassword = _useState5[1];
    return /*#__PURE__*/ _jsxs(LoginWrapper, {
        children: [
            /*#__PURE__*/ _jsx(Typography, {
                variant: "displaySSerifRegular",
                children: signInTitle
            }),
            withEmail ? /*#__PURE__*/ _jsxs(_Fragment, {
                children: [
                    /*#__PURE__*/ _jsx(Spacer, {
                        height: "1x"
                    }),
                    /*#__PURE__*/ _jsx(Typography, {
                        children: defaultEmail
                    }),
                    /*#__PURE__*/ _jsx(Spacer, {
                        height: "3x"
                    })
                ]
            }) : null,
            /*#__PURE__*/ _jsx(Input, {
                label: strictLocalize({
                    id: "7teRwl",
                    defaultMessage: [
                        {
                            type: 0,
                            value: "Password"
                        }
                    ]
                }),
                autoFocus: true,
                autoComplete: "password",
                role: "password",
                "aria-label": strictLocalize({
                    id: "ozd6Zd",
                    defaultMessage: [
                        {
                            type: 0,
                            value: "Password"
                        }
                    ]
                }),
                name: "password",
                type: showPassword ? "text" : "password",
                suffixNode: /*#__PURE__*/ _jsx("button", {
                    type: "button",
                    "data-test-id": "eye-button",
                    onClick: function() {
                        setShowPassword(!showPassword);
                    },
                    children: showPassword ? /*#__PURE__*/ _jsx(Eye, {
                        color: Core.text.subdued,
                        fontSize: "24px"
                    }) : /*#__PURE__*/ _jsx(EyeClosed, {
                        color: Core.text.subdued,
                        fontSize: "24px"
                    })
                }),
                "data-test-id": "password",
                value: password,
                onChange: handleChange,
                onBlur: function() {
                    trackFieldValue("userpassword", "");
                },
                onKeyDown: handleKeyDown(onContinue),
                error: passwordError
            }),
            passwordError ? /*#__PURE__*/ _jsx(Spacer, {
                height: "1x"
            }) : /*#__PURE__*/ _jsx(Spacer, {
                height: "3x"
            }),
            magicLinkProminenceVariant !== ISignInMagicLinkXP.Bucket.VARIANT_B ? /*#__PURE__*/ _jsxs(_Fragment, {
                children: [
                    /*#__PURE__*/ _jsx(Button, {
                        style: {
                            alignSelf: "flex-start"
                        },
                        variant: "tertiary",
                        onClick: function() {
                            onForgotPassword(defaultEmail);
                            trackSigninResetPasswordClick(View.ENTER_PASSWORD);
                        },
                        "data-test-id": "reset-pswd-link",
                        children: /*#__PURE__*/ _jsx(StrictLocalMsg, {
                            id: "fTiJ2a",
                            defaultMessage: [
                                {
                                    type: 0,
                                    value: "Forgot password?"
                                }
                            ]
                        })
                    }),
                    /*#__PURE__*/ _jsx(Spacer, {
                        height: "3x"
                    })
                ]
            }) : null,
            /*#__PURE__*/ _jsx(ContinueToNextViewButton, {
                onClick: onContinue,
                isLoading: isLoading,
                TextOverride: /*#__PURE__*/ _jsx(StrictLocalMsg, {
                    id: "MfO/qT",
                    defaultMessage: [
                        {
                            type: 0,
                            value: "Sign in"
                        }
                    ]
                })
            }),
            /*#__PURE__*/ _jsx(ErrorMessage, {
                error: error,
                align: "left",
                small: true
            }),
            error ? null : /*#__PURE__*/ _jsx(Spacer, {
                height: "3x"
            }),
            /*#__PURE__*/ _jsxs(Row, {
                align: "center",
                children: [
                    /*#__PURE__*/ _jsx(HorizontalLine, {}),
                    /*#__PURE__*/ _jsx(Spacer, {
                        width: "2x"
                    }),
                    /*#__PURE__*/ _jsx(Typography, {
                        children: /*#__PURE__*/ _jsx(StrictLocalMsg, {
                            id: "WuBWZA",
                            defaultMessage: [
                                {
                                    type: 0,
                                    value: "or"
                                }
                            ]
                        })
                    }),
                    /*#__PURE__*/ _jsx(Spacer, {
                        width: "2x"
                    }),
                    /*#__PURE__*/ _jsx(HorizontalLine, {})
                ]
            }),
            /*#__PURE__*/ _jsx(Spacer, {
                height: "3x"
            }),
            /*#__PURE__*/ _jsx(SendMagicLinkButton, {
                onClick: onMagicLink,
                "data-test-id": "send-magic-link-bttn",
                disabled: isLoading,
                children: magicLinkProminenceVariant === ISignInMagicLinkXP.Bucket.CONTROL ? /*#__PURE__*/ _jsx(StrictLocalMsg, {
                    id: "qVJHC3",
                    defaultMessage: [
                        {
                            type: 0,
                            value: "Email me a link to sign in"
                        }
                    ]
                }) : /*#__PURE__*/ _jsx(StrictLocalMsg, {
                    id: "WAROQa",
                    defaultMessage: [
                        {
                            type: 0,
                            value: "Email me a code"
                        }
                    ]
                })
            })
        ]
    });
};
// This is a temporary quick fix for a translation issue.
// This styled should be removed once french fits in a single line
// or once our button handles multi line content
var SendMagicLinkButton = styled(Button).attrs({
    variant: "secondary"
}).withConfig({
    componentId: "sc-63f7b9bb-0"
})([
    "line-height:20px;"
]);
